import React from 'react'
import { useRouter } from 'next/router'

import { Badge } from '@wartek-id/badge'

import LoadingSpinner from '../components/LoadingSpinner'
import DiskusiPersiapanForm from './DiskusiPersiapanForm'
import DiskusiPersiapanViewOnly from './DiskusiPersiapanViewOnly'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { usePelaksanaanPraktikKinerjaPS } from 'app/KinerjaPSPegawaiPage/hooks/usePelaksanaanPraktikKinerjaPS'
import { Header } from 'app/KinerjaShared/components/Header'
import usePPSPeriodGuard from 'app/KinerjaPSPegawaiPage/hooks/usePPSPeriodGuard'

import type { TPraktikKinerjaDiskusiPersiapanFormValue } from 'types/kinerja-ps-pegawai'

export default function PSPelaksanaanDiskusiPersiapanPage() {
  const router = useRouter()
  const [isPageLoading, setPageLoading] = React.useState(true)

  // Entry Point Guards
  const { isPeriodSuccess, pelaksanaanGuard } = usePPSPeriodGuard()

  const {
    psSummaryHookResult: {
      summaryFetchStatus: psSummaryFetchStatus,
      isPelaksanaanState,
    },

    formStatus,
    parsedFormValues,

    perencanaanSummary,
    perencanaanSummaryStatus,

    submitFormValues,
    submitStatus,

    isViewOnly,
    isAppeal,
  } = usePelaksanaanPraktikKinerjaPS<TPraktikKinerjaDiskusiPersiapanFormValue>({
    formName: 'diskusi_persiapan',
  })

  React.useEffect(() => {
    if (isPeriodSuccess && !pelaksanaanGuard.isOpen) {
      router.replace(PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH)
    } else if (isPeriodSuccess && psSummaryFetchStatus === 'success') {
      setPageLoading(false)
    }
  }, [isPeriodSuccess, psSummaryFetchStatus, pelaksanaanGuard.isOpen, router])

  if (isPageLoading) {
    return (
      <div className="px-3 mx-auto max-w-7xl py-9">
        <LoadingSpinner />
      </div>
    )
  }

  if (!isPelaksanaanState) {
    router.replace(PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH)

    return null
  }

  const isLoading =
    formStatus === 'loading' || perencanaanSummaryStatus === 'loading'
  const isFetched =
    formStatus === 'success' && perencanaanSummaryStatus === 'success'

  return (
    <div className="px-3 mx-auto max-w-7xl py-9">
      <Header
        title={
          <div className="flex items-center gap-x-3">
            Diskusi Persiapan
            {isViewOnly && !isAppeal && (
              <Badge variant="success">Selesai</Badge>
            )}
            {isAppeal && (
              <Badge variant="neutral">Perubahan sedang diajukan</Badge>
            )}
          </div>
        }
        className="mb-6"
      />

      {isViewOnly ? (
        <DiskusiPersiapanViewOnly
          formValues={parsedFormValues}
          perencanaanSummary={perencanaanSummary}
          isLoading={isLoading}
          isFetched={isFetched}
        />
      ) : (
        <DiskusiPersiapanForm
          formValues={parsedFormValues}
          perencanaanSummary={perencanaanSummary}
          isLoading={isLoading}
          isFetched={isFetched}
          onSubmitFormValues={submitFormValues}
          submitStatus={submitStatus}
        />
      )}
    </div>
  )
}
